<template>
<div id="bgc">
  <div class="container">
    <h2>导航发布页</h2>
    <div class="sites">
      <p style="color: #1dd1a1">永久网址： <a href="https://acgnv3.pages.dev">acgnv3.pages.dev</a></p>
           <p style="color: #ff4d4f">主域名： <a href="https://acg.cloudns.org">acg.cloudns.org</a></p>
                <p style="color: #1685a9">备用域名： <a href="https://ecy.de5.net">ecy.de5.net</a></p>   
                      <h4>本站不接广告，目前暂停收录、请勿联系，谢谢。<br>若需要删除贵站链接请联系邮箱<br>mail#acg.cloudns.org(#替换为@)</h4>    
    </div>
    <div class="link-card">
      <a  class="links" href="https://yyzs.cloudns.org/" target="_blank">ACGN资源博客</a>
    </div>

    
   

  </div>
</div>  
</template>
<script setup>

</script>
<script>
export default {
  data() {
    return {
      emailToCopy: 'mail@acg.cloudns.org',
      copySuccess: false, 
    };
  },
  methods: {
    async copymail() {
      try {
        await navigator.clipboard.writeText(this.emailToCopy);
        console.log('邮箱地址已复制');
        this.showSuccessTip();
      } catch (err) {
        console.error('无法复制文本: ', err);
        alert('复制失败，请手动复制: ' + this.emailToCopy);
      }
    },
    showSuccessTip() {
      this.copySuccess = true;
      setTimeout(() => {
        this.copySuccess = false;
      }, 2000); 
    }
  }
};
</script>

<style scoped>
    .button-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      text-align: center;
    }

    .cbox{
      background-color: #4a6baf;
      border-radius: 8px;
      margin-top: 5px;
      padding: 10px 25px;
      transition: all 0.3s ease;
      position: relative;
      display: inline-block;
    }

    .cbox:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }

    .clink{
      color: white;
      text-decoration: none;
      display: block;
      text-align: center;
      font-weight: bold;
      cursor: pointer; 
    }
    .copy-success-tip {
      position: absolute;
      bottom: 120%; 
      left: 50%;
      transform: translateX(-50%);
      background-color: #4CAF50; 
      color: white;
      padding: 5px 10px;
      border-radius: 4px;
      white-space: nowrap;
      font-size: 14px;
}

    .description {
      background-color: rgba(255, 255, 255, 0.85);
      padding: 15px;
      border-radius: 8px;
      line-height: 1.5;
      margin: 0;
    }
    .thr{margin:0 auto; font-size: 18px;color: #ff4d4f;}
    .th{font-weight: bold;}

  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden; 
  }
  .notice{
    background-color: rgb(244, 238, 238,0.9);
    padding: 10px;
    color: black;
    text-decoration: none;
    border-radius: 10px;
    transition: background-color 0.3s ease; 
    transition: transform 0.3s;
  } 
  #about{ color: red; }
  #bgc {
    background-image: url('../../public/bg.png'); 
    background-size: cover; 
    background-position: center; 
    background-repeat: no-repeat;
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    padding: 0;
    margin: 0;
  }
  #card-content{
    z-index: 999;
    margin: 0 auto;
    width: auto;
    height: 210px;
    background-color: #fff;
    color: black;
    border-bottom: black;
    border-radius: 10px;
    margin-top: 10px;
    padding-top: 5px ;
  }

  h2{color: gray;}
  .container {
    margin: 0 auto;
    margin-top: 30px;
    width: 90%;
    max-width: 450px;
    border-radius: 15px;
    background-color: rgb(244, 238, 238, 0.7);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 20px;
    text-align: center;
    overflow: auto;
    }
  .sites{
    font-weight:bold;
    padding: 1px;
    margin-bottom: 15px;
    background-color: rgb(255, 251, 251,0.9);
    border-radius: 15px; 
  }

a {
  color: #2c3e50; /* 深灰色文字，优雅 */
  text-decoration: none; /* 去掉下划线 */
  position: relative;
  transition: color 0.3s ease, text-shadow 0.3s ease; /* 平滑过渡 */
}

a:hover {
  color: #3498db; /* 悬停时变为蓝色 */
  text-shadow: 0 0 8px rgba(52, 152, 219, 0.8); /* 添加柔和的蓝色光晕 */
}

/* 保证键盘Tab键选中时也有轮廓，提升可访问性 */
a:focus {
  outline: 2px dashed #3498db;
  outline-offset: 2px;
}


        @media (max-width:767px){
          span{
            font-size: 14px;
          }

            .container{
                width: 90%;
                height: 80%;
            }
            #card-content{
              width: 95%;
            }
            
            .button-group {
              gap: 10px;
              align-items: center;
            }
            .cbox {
              width: 50%;
              height: 45%;
              max-width: 50px;
            }
      }

        .links {
            display: block;
            margin-bottom: 15px;
            padding: 15px;
            font-weight: bold;
            background-color:rgba(255, 255, 255, 0.5);
            color: black;
            border-radius: 25px;
            text-decoration: none;
            transition: background-color 0.3s ease; 
            transition: transform 0.3s;
        }

        .link-card:hover{
            transform: translateY(-3px);
        }
</style>